import type { LinkableDlnItemsResponse } from './types';
import type { InfiniteData } from '@tanstack/react-query';

/** Flattens the loaded pages and keeps the latest page's counts. */
export function selectLinkableDlnItemPages(
  data: InfiniteData<LinkableDlnItemsResponse>,
) {
  const latestPage = data.pages.at(-1);

  return {
    deliveryNoteCount: latestPage?.deliveryNoteCount ?? 0,
    hasNextPage: latestPage?.hasNextPage ?? false,
    items: data.pages.flatMap((page) => page.data),
    sameArticleNumberCount: latestPage?.sameArticleNumberCount ?? 0,
    totalCount: latestPage?.totalCount ?? 0,
  };
}
